import { __spreadArray } from "tslib";
import * as DOMPurify from 'isomorphic-dompurify';
import Long from 'long';
import moment from 'moment';
export var sanitizeHtml = function (html) {
    var DEFAULT_ALLOWED_TAGS_FROM_SANITIZE_HTML = [
        'address',
        'article',
        'aside',
        'footer',
        'header',
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'hgroup',
        'main',
        'nav',
        'section',
        'blockquote',
        'dd',
        'div',
        'dl',
        'dt',
        'figcaption',
        'figure',
        'hr',
        'li',
        'main',
        'ol',
        'p',
        'pre',
        'ul',
        'a',
        'abbr',
        'b',
        'bdi',
        'bdo',
        'br',
        'cite',
        'code',
        'data',
        'dfn',
        'em',
        'i',
        'kbd',
        'mark',
        'q',
        'rb',
        'rp',
        'rt',
        'rtc',
        'ruby',
        's',
        'samp',
        'small',
        'span',
        'strong',
        'sub',
        'sup',
        'time',
        'u',
        'var',
        'wbr',
        'caption',
        'col',
        'colgroup',
        'table',
        'tbody',
        'td',
        'tfoot',
        'th',
        'thead',
        'tr',
        'img',
        'bold',
        'span',
    ];
    var DEFAULT_ALLOWED_TAGS = __spreadArray(__spreadArray([], DEFAULT_ALLOWED_TAGS_FROM_SANITIZE_HTML, true), [
        'img',
        'bold',
        'span',
    ], false);
    var DEFAULT_ALLOWED_ATTRS = [
        'class',
        'src',
        'bold',
        'img',
        'span',
        'href',
        'target',
        'width',
        'height',
    ];
    DOMPurify.addHook('afterSanitizeAttributes', function (node) {
        if (node.tagName === 'IMG') {
            var rawSrc = node.getAttribute('src') || '';
            if (rawSrc) {
                var processedSrc = rawSrc.replace('http://', 'https://');
                node.setAttribute('src', processedSrc);
            }
        }
        else {
            node.removeAttribute('width');
            node.removeAttribute('height');
        }
    });
    var sanitizedHtml = DOMPurify.sanitize(html, {
        ALLOWED_TAGS: DEFAULT_ALLOWED_TAGS,
        ALLOWED_ATTR: DEFAULT_ALLOWED_ATTRS,
    });
    DOMPurify.removeAllHooks();
    return sanitizedHtml;
};
export var launchedTagText = function (eta, t) {
    var mum = typeof eta === 'number' ? eta : new Long(eta.low, eta.high).toNumber();
    var month = moment.utc(mum).utcOffset('UTC').locale('en').month();
    var monthText = t("month.".concat(month));
    var year = moment.utc(mum).utcOffset('UTC').locale('en').year();
    return t('shared.roadmap.article-list.resolutions.launched', {
        month: monthText,
        year: year,
    });
};
export var getQuarter = function (eta) {
    var mum = typeof eta === 'number' ? eta : new Long(eta.low, eta.high).toNumber();
    var monthTZ = moment.utc(mum).utcOffset('UTC').locale('en').month();
    var year = moment.utc(mum).utcOffset('UTC').locale('en').year();
    var quarter = Math.ceil(monthTZ / 3);
    return {
        quarter: quarter,
        year: year,
    };
};
//# sourceMappingURL=text.js.map